export const getRolePrefix = (roleName: string): string => {
  if (!roleName) return "";
  return "/" + roleName.toLowerCase().replace(/\s+/g, "-");
};

export const RoutesLink = {
  // Auth Routes
  authRoutes: {
    login: "/",
    ssoLogin: "/sso-login",
    forgot: "/forgot",
    signUp: "/join-now",
    verifyOtp: "/verify-otp",
    resetPassword: "/reset-password",
  },
  forbidden_403: "/forbidden-403",
  // user
  userDashboard: "/dashboard",
  superAdminDashboard: "/dashboard",
  superAdminEmployees: "/employees",
  superAdminEmplyoeeOnboard: "/employee-onboard",
  addEmplyoeeOnboard: "/add-employee-onboard",
  editEmplyoeeOnboard: "/edit-employee-onboard",
  createEmployee: "/create-employee",
  editEmployee: "/edit-employee",
  employeeDetail: "/employee-detail",

  // Profile
  profile: "/profile",
  editProfile: "/edit-profile",
  // viewProfile: "/view-profile/",

  // attendance
  myAttendance: "/my-attendance",
  teamAttendance: "/team-attendance",
  attendanceLog: "/attendance-log",

  // WFH
  addWfh: "/add-wfh",
  wfhRequest: "/wfh-request",
  teamWfh: "/wfh-team",
  wfhDetail: "/wfh-detail",
  teamWfhDetail: "/wfh-team-detail",

  // Payslip
  payslip: "/payslip",
  payslipDetail: "/payslip/detail",

  // OD
  myOd: "/od-request",
  teamOd: "/od-team",
  createOd: "/create-od",
  odDetail: "/od-detail",
  teamOdDetail: "/team-od-detail",

  // Company
  company: "/company",
  createCompany: "/create-company",
  editCompany: "/edit-company",

  //   department
  superAdminDepartment: "/department",
  addDepartment: "/add-department",
  editDepartment: "/edit-department",
  //   branch
  superAdminBranch: "/branch",
  addBranch: "/add-branch",
  editBranch: "/edit-branch",
  //   shift and time
  shiftAndTime: "/shift-and-time",
  addShiftAndTime: "/add-shift-and-time",
  editShiftAndTime: "/edit-shift-and-time",

  //   designation
  superAdminDesignation: "/designation",
  addDesignation: "/add-designation",
  editDesignation: "/edit-designation",

  // campus
  superAdminCampus: "/campus",
  addCampus: "/add-campus",
  editCampus: "/edit-campus",

  // applications
  superAdminApplication: "/application",
  addApplication: "/add-application",
  editApplication: "/edit-application",

  // Common Routes
  dashboard: "/dashboard",
  // forbidden_403: "/forbidden-403",

  // Super Admin Routes
  // superAdminDashboard: "/dashboard",

  // Leave Setting
  leaveSetting: "/leave-setting",
  addLeaveSetting: "/add-leave-setting",
  editLeaveSetting: "/edit-leave-setting",

  // Leave
  addLeave: "/add-leave",
  editLeave: "/edit-leave",
  leaveDetail: "/leave-detail",
  teamLeaveDetail: "/team-leave-detail",
  teamLeave: "/team-leave",
  myLeave: "/my-leave",

  // Admin Routes
  adminCompare: "/admin/compare",
  adminOrg: "/admin/org",
  adminTemplates: "/admin/templates",
  adminAudit: "/admin/audit",
  adminSettings: "/admin/settings",

  // Site
  superAdminSite: "/site",
  addSite: "/add-site",
  editSite: "/edit-site",
};
// };
